import { novaClient } from "@/lib/trpc";

// Both caches are invalidated by userId rather than written directly. The sheet
// profile is keyed on (userId, jobId, city, state) and several entries can exist
// for one user, so there is no single input to setData against.
export function useUpdateSetShiftPreferences() {
  const novaClientUtils = novaClient.useUtils();

  return novaClient.internal.user.profile.shiftPreference.set.useMutation({
    onSuccess: (_shiftPreferences, { userId }) => {
      void novaClientUtils.internal.user.active.getCandidacySheetData.invalidate(
        { userId },
      );
      // The edit lands in the trail as EDIT rows, so the citation timeline
      // under the Shift row is stale too.
      void novaClientUtils.internal.user.paperTrail.citationsForUser.invalidate(
        {
          userId,
        },
      );
    },
  });
}
